module.exports = __webpack_public_path__ + "static/media/img_naver_pay.c900a2d5.png";